import './Animations.scss';
import template from './Animations.vhtml';

export default {
	name: 'Animations',
	template: template,
	props: {
		effect: {
			type: String,
			default: 'fade',
		},
	},
	data: () => ({
		show: false,
	}),
	computed: {},
	methods: {},
	mounted() {
		this.show = true;
	},
};
